import { combineReducers } from 'redux';
import { YoutubeSubscriptionsReducer } from '../subscriptions/YoutubeSubscriptionsReducer';
import { YoutubeDialogsReducer } from '../dialogs/YoutubeDialogsReducer';

export const YoutubeReducer = combineReducers({
  subscriptions: YoutubeSubscriptionsReducer,
  dialogs: YoutubeDialogsReducer,
});
